import { render, staticRenderFns } from "./questionMarkPrompt.vue?vue&type=template&id=d755121c&scoped=true"
import script from "./questionMarkPrompt.vue?vue&type=script&lang=js"
export * from "./questionMarkPrompt.vue?vue&type=script&lang=js"
import style0 from "./questionMarkPrompt.vue?vue&type=style&index=0&id=d755121c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d755121c",
  null
  
)

export default component.exports